import { GalaxyConfig, StarData, StarPosition } from 'types/galaxy';

export const calculateSpringPositions = (
  starsData: StarData[],
  _config: GalaxyConfig
): StarPosition[] => {
  const helixRadius = 18;
  const height = 140;
  const turns = 20;
  const strandThickness = 0.6;
  const rungFraction = 0.08;

  // Split into profit and loss, sort within each group
  const profitTraders: { idx: number; pnl: number }[] = [];
  const lossTraders: { idx: number; pnl: number }[] = [];
  starsData.forEach((star, i) => {
    if (star.pnl >= 0) profitTraders.push({ idx: i, pnl: star.pnl });
    else lossTraders.push({ idx: i, pnl: star.pnl });
  });
  profitTraders.sort((a, b) => b.pnl - a.pnl);
  lossTraders.sort((a, b) => a.pnl - b.pnl);

  const positions: StarPosition[] = new Array(starsData.length);

  function placeOnStrand(arr: { idx: number }[], phaseOffset: number) {
    const rungCount = Math.floor(arr.length * rungFraction);
    const strandCount = arr.length - rungCount;

    // STRAND
    for (let j = 0; j < strandCount; j++) {
      const idx = arr[j].idx;
      const t = j / Math.max(strandCount - 1, 1);
      const y = height / 2 - t * height;
      const angle = t * turns * Math.PI * 2 + phaseOffset;
      const tangentX = -Math.sin(angle);
      const tangentZ = Math.cos(angle);
      const offsetAlong = (Math.random() - 0.5) * strandThickness;
      const offsetRadial = (Math.random() - 0.5) * strandThickness * 0.5;

      positions[idx] = {
        x: Math.cos(angle) * (helixRadius + offsetRadial) + tangentX * offsetAlong,
        y: y + (Math.random() - 0.5) * strandThickness,
        z: Math.sin(angle) * (helixRadius + offsetRadial) + tangentZ * offsetAlong,
      };
    }

    // RUNGS
    for (let j = 0; j < rungCount; j++) {
      const idx = arr[strandCount + j].idx;
      const t = (j + 0.5) / rungCount;
      const y = height / 2 - t * height;
      const angle = t * turns * Math.PI * 2 + phaseOffset;
      const oppositeAngle = angle + Math.PI;
      const rungT = Math.random();
      const x1 = Math.cos(angle) * helixRadius;
      const z1 = Math.sin(angle) * helixRadius;
      const x2 = Math.cos(oppositeAngle) * helixRadius;
      const z2 = Math.sin(oppositeAngle) * helixRadius;

      positions[idx] = {
        x: x1 + (x2 - x1) * rungT + (Math.random() - 0.5) * 0.4,
        y: y + (Math.random() - 0.5) * 0.4,
        z: z1 + (z2 - z1) * rungT + (Math.random() - 0.5) * 0.4,
      };
    }
  }

  placeOnStrand(profitTraders, 0);
  placeOnStrand(lossTraders, Math.PI);

  return positions;
};
